// extracted by mini-css-extract-plugin
export default {"secondaryIcons":"secondaryIcons--oNCqq","selectedIcon":"selectedIcon--P1vJb","drag-handler":"drag-handler--v_pUt"};